import { useState } from 'react'

export const useLocalTaskStatus = () => {

    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);

    return [error, loading, setError, setLoading];
}
